module.exports = __webpack_public_path__ + "assets/img/statue-2.0cb560dd.png";